<template>
  <span v-html="sanitizedHtml"></span>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  keypath: { type: String, required: true },
  values: { type: Object, default: () => ({}) },
  highlightKey: { type: String, default: 'propName' }
});

const { t } = useI18n();

function escapeHtml(text) {
  if (!text) return '';
  return text
    .toString()
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

const sanitizedHtml = computed(() => {
  const translated = t(props.keypath, props.values);
  const rawValue = props.values[props.highlightKey] || '';
  const safeValue = escapeHtml(rawValue);
  const strongTag = `<strong>${safeValue}</strong>`;
  return translated.replaceAll(rawValue, strongTag);
});
</script>
